import { axiosInstance as axios } from "services";

export const fetchAccountHealth = async (companyId) => {
  const { data } = await axios.get(`/admin/subscription/company/${companyId}/account-health`);
  if (!data.success) throw new Error(data.error?.message || "Failed to fetch account health");
  return data;
};
